import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ClosePanelButtonProps {
  onClick: () => void;
  ariaLabel: string;
}

export const ClosePanelButton: React.FC<ClosePanelButtonProps> = ({
  onClick,
  ariaLabel,
}) => {
  return (
    <Button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      variant="ghost"
      size="icon"
      className="h-10 w-10 shrink-0"
    >
      <X className="h-5 w-5" />
    </Button>
  );
};
